import React, {useState} from "react";
import Collapsible from "react-collapsible";
import {Box, Button, Columns, Form} from "react-bulma-components";
import {fixed} from "lodash/fp/_falseOptions";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";


const AsyncTypeahead = asyncContainer(Typeahead);

export default function NewFixedExpense({onSave, departments, departmentObjects}){
    const [fixedExpense, setFixedExpense] = useState({
        description: "",
        supplier: {},
        yearly_amount: 0,
        department: departments[0],
        start_date: null,
        renewal_date: null
    });

    const clear = () => {
        setFixedExpense({
            description: "",
            supplier: {},
            yearly_amount: 0,
            department: departments[0],
            start_date: null,
            renewal_date: null
        });
    };

    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const onChange = e => {
        let newFixedExpense = {...fixedExpense};
        newFixedExpense[e.target.name] = e.target.value;
        setFixedExpense(newFixedExpense);
    }

    const onDepartmentChange = e => {
        const toUpdate = {
            target: {
                name: "department",
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate);
    }

    const onSupplierChange = e => {
        const toUpdate = {
            target: {
                name: "supplier",
                value: e[0]
            }
        };
        onChange(toUpdate);
    }

    return (
        <Box>
            <Collapsible
                className={"title"}
                triggerOpenedClassName={"title"}
                trigger={"Add Fixed Expense"}
            >
                <Columns>
                    <Columns.Column>
                        <Form.Label>Department</Form.Label>
                        <DepartmentSelector
                            options={departments}
                            value={fixedExpense.department}
                            blank={true}
                            onChange={onDepartmentChange}
                            name={"department"}
                            editable={true}
                            disabled={false}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Supplier</Form.Label>
                        <Form.Field className="has-addons">
                          <AsyncTypeahead
                              useCache={false}
                              id="typeahead"
                              labelKey="display_name"
                              minLength={2}
                              name={"supplier"}
                              onSearch={handleSearch}
                              onChange={onSupplierChange}
                              placeholder={"Search Supplier"}
                              options={searchData}
                              ref={typeahead => setTypeahead(typeahead)}
                              className="typeahead"
                              isLoading={isLoading}
                              selected={
                                fixedExpense.supplier && fixedExpense.supplier.id ? [fixedExpense.supplier] : []
                              }
                          />
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Description</Form.Label>
                        <Form.Textarea
                            value={fixedExpense.description}
                            onChange={onChange}
                            name={"description"}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Input
                            type={"date"}
                            onChange={onChange}
                            name={"start_date"}
                            value={fixedExpense.start_date}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Renewal Date</Form.Label>
                        <Form.Input
                            type={"date"}
                            onChange={onChange}
                            name={"renewal_date"}
                            value={fixedExpense.renewal_date}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Yearly Amount (£)</Form.Label>
                        <Form.Input
                            type={"number"}
                            value={fixedExpense.yearly_amount}
                            onChange={onChange}
                            name={"yearly_amount"}
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            onClick={() => onSave(fixedExpense)}
                        >
                            Create
                        </Button>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )


}